import React from "react";
import Nav from "../Nav/Nav";
import "./Live.css";

const Live = (props) => {
  return (
    <React.Fragment>
      <Nav />
      <div className="live-container">
        <div className="live-picture"></div>
        <div className="live-details">
          <div className="live-intro">
            <div className="live-title">Sunday Jazz Brunch with Yojimbo Jazz</div>
            <div className="gig-details">
              We're playing jazz brunches around Uptown on Sundays this fall and winter, 11am to 1pm.
              Bring a friend, grab a table and enjoy great food and coffee &mdash; we'd love to see you there.
            </div>
          </div>
          <div className="gig">
            <div className="gig-header">
              Gigi's Cafe &mdash; Sundays October 25th, November 22nd and December 20th
            </div>
            <div className="gig-venue">
              Gigi's Cafe, 824 W 36th St, Minneapolis, MN 55408 &mdash;{" "}
              <a
                href="https://www.gigisuptown.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                gigisuptown.com
              </a>
            </div>
          </div>
          <div className="gig">
            <div className="gig-header">
              Thesis Coffee Collective &mdash; Sundays November 15th and December 13th
            </div>
            <div className="gig-venue">
              Thesis Coffee Collective, 3142 Hennepin Ave, Minneapolis, MN 55408 &mdash;{" "}
              <a
                href="https://thesiscoffeeco.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                thesiscoffeeco.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Live;
